// Регистрация панели уведомлений в каркасе. Побочный эффект при загрузке: уведомления —
// общая поверхность, а не раздел, поэтому регистрация живёт рядом с ними и импортируется
// каркасом защищённой области, а не разделом.

import { registerPanel } from '@/layout/panel-registry';

import { NotificationsPanel } from './NotificationsPanel';

/** Вид панели в адресе: `?p=notifications:all`. */
export const PANEL_NOTIFICATIONS = 'notifications';

registerPanel(PANEL_NOTIFICATIONS, {
  title: () => 'Уведомления',
  render: ({ onClose }) => <NotificationsPanel onClose={onClose} />,
});
